import _AccountTutorQuery from "../__generated__/AccountTutorQuery.graphql";
import { graphql, useLazyLoadQuery } from 'react-relay';
import type { AccountTutorQuery } from '../__generated__/AccountTutorQuery.graphql';
import { CharacterSelect } from './CharacterSelect.tsx';
import { TutorVolume } from './TutorVolume.tsx';
const AccountTutorQuery = (_AccountTutorQuery.hash && _AccountTutorQuery.hash !== "02a1628a5b708dec1ce9c37fd3ca71f7" && console.error("The definition of 'AccountTutorQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _AccountTutorQuery);
export function AccountTutor() {
  const data = useLazyLoadQuery<AccountTutorQuery>(AccountTutorQuery, {});
  const defaultCharacter = data.me?.learner?.defaultCharacter;
  return <div className="flex flex-col gap-6">
      <CharacterSelect chosen={defaultCharacter?.id ?? null} embedded />
      {/* Beside the character and the voice rather than in Settings: this is
          how loud *this tutor* speaks, and the two decisions are made in the
          same sitting. */}
      <TutorVolume />
    </div>;
}